import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fdfb55e&scoped=true"
import script from "./message.js?vue&type=script&lang=js&external"
export * from "./message.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=2fdfb55e&prod&lang=scss&scoped=true&external"
import style1 from "./styles.global.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdfb55e",
  null
  
)

export default component.exports